import { defineStore } from 'pinia'
import { computed, ref, watch } from 'vue'
import { useRoute } from 'vue-router'
import { useFetch } from '@/modules/shared/composables/use-fetch'

///////////////////////////////////////////////////////////////////////////////
// Types
///////////////////////////////////////////////////////////////////////////////

type Country = [string, string]
type State = [string, string]

///////////////////////////////////////////////////////////////////////////////
// Store
///////////////////////////////////////////////////////////////////////////////

export const useAddressStore = defineStore('shared/addressStore', () => {
  const route = useRoute()
  const baseUrl = computed(() => `/${route.params.slug}/shared`)

  const countries = ref<Country[]>([])
  const states = ref<State[]>([])

  const fetchCountries = async () => {
    let url = `${baseUrl.value}/countries`

    const { data, error } = await useFetch(url).get().json<{ data: Country[] }>()

    if (error.value) {
      console.error(error.value)
      return
    }

    countries.value = data.value.data
  }

  const fetchStates = async (countryCode: string) => {
    let url = `${baseUrl.value}/states?country=${countryCode}`

    const { data, error } = await useFetch(url).get().json<{ data: State[] }>()

    if (error.value) {
      console.error(error.value)
      return
    }

    states.value = data.value.data
  }

  ///////////////////////////////////////////////////////////////////////////////
  // Options
  ///////////////////////////////////////////////////////////////////////////////

  const countryOptions = computed(() =>
    countries.value.map((country) => {
      return {
        label: country[0],
        value: country[1],
      }
    }),
  )

  const stateOptions = computed(() =>
    states.value.map((state) => {
      return {
        label: state[0],
        value: state[1],
      }
    }),
  )

  return {
    countries,
    states,

    countryOptions,
    stateOptions,

    fetchCountries,
    fetchStates,
  }
})
